var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/convert-config.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import "@adornis/baseql/entities/mongoEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
var FieldMappingEntry = class extends AdornisEntity {
  constructor(doc, deserialize = (value, data, i, entityInitializer) => value, serialize = (value, data, i) => value?.toString() ?? "") {
    super(doc);
    this.deserialize = deserialize;
    this.serialize = serialize;
  }
};
FieldMappingEntry._class = "FieldMappingEntry";
__decorateClass([
  Field((type) => String)
], FieldMappingEntry.prototype, "input", 2);
__decorateClass([
  Field((type) => String)
], FieldMappingEntry.prototype, "output", 2);
FieldMappingEntry = __decorateClass([
  Entity()
], FieldMappingEntry);
var NumberFieldMappingEntry = class extends FieldMappingEntry {
  constructor() {
    super(...arguments);
    this.deserialize = (v) => {
      if (isNaN(+v))
        throw new Error(`cant convert ${v + ""} to number while importing`);
      return +v;
    };
  }
};
NumberFieldMappingEntry._class = "NumberFieldMappingEntry";
NumberFieldMappingEntry = __decorateClass([
  Entity()
], NumberFieldMappingEntry);
var MaybeNumberFieldMappingEntry = class extends FieldMappingEntry {
  constructor() {
    super(...arguments);
    this.deserialize = (v) => {
      if (v === "")
        return null;
      if (isNaN(+v))
        throw new Error(`cant convert ${v + ""} to number while importing`);
      return +v;
    };
  }
};
MaybeNumberFieldMappingEntry._class = "MaybeNumberFieldMappingEntry";
MaybeNumberFieldMappingEntry = __decorateClass([
  Entity()
], MaybeNumberFieldMappingEntry);
var BooleanFieldMappingEntry = class extends FieldMappingEntry {
  constructor() {
    super(...arguments);
    this.deserialize = (v) => {
      if (v === "")
        return null;
      if (v === "false")
        return false;
      if (v === "true")
        return true;
      throw new Error(`cant convert ${v + ""} to boolean while importing`);
    };
  }
};
BooleanFieldMappingEntry._class = "BooleanFieldMappingEntry";
BooleanFieldMappingEntry = __decorateClass([
  Entity()
], BooleanFieldMappingEntry);
var ForeignKeyMapping = class extends AdornisEntity {
  get constr() {
    const constr = baseqlMetaData.entities.find((node) => node.type()._class === this.className)?.type();
    if (!constr)
      throw new Error("cant find class " + this.className);
    return constr;
  }
};
ForeignKeyMapping._class = "ForeignKeyMapping";
__decorateClass([
  Field((type) => String)
], ForeignKeyMapping.prototype, "keyOnHost", 2);
__decorateClass([
  Field((type) => String)
], ForeignKeyMapping.prototype, "className", 2);
__decorateClass([
  Field((type) => [FieldMappingEntry])
], ForeignKeyMapping.prototype, "fieldMappings", 2);
__decorateClass([
  Field((type) => String)
], ForeignKeyMapping.prototype, "uniqueIdentifierFieldName", 2);
ForeignKeyMapping = __decorateClass([
  Entity()
], ForeignKeyMapping);
var ConvertConfig = class extends AdornisEntity {
  get constr() {
    const constr = baseqlMetaData.entities.find((node) => node.type()._class === this.className)?.type();
    if (!constr)
      throw new Error("cant find class " + this.className);
    return constr;
  }
  constructor(doc) {
    super(doc);
  }
};
ConvertConfig._class = "ConvertConfig";
__decorateClass([
  Field((type) => String)
], ConvertConfig.prototype, "encoding", 2);
__decorateClass([
  Field((type) => String)
], ConvertConfig.prototype, "delimiter", 2);
__decorateClass([
  Field((type) => [FieldMappingEntry])
], ConvertConfig.prototype, "fieldMappings", 2);
__decorateClass([
  Field((type) => String)
], ConvertConfig.prototype, "className", 2);
__decorateClass([
  Field((type) => String)
], ConvertConfig.prototype, "uniqueIdentifierFieldName", 2);
__decorateClass([
  Field((type) => [ForeignKeyMapping])
], ConvertConfig.prototype, "foreignKeys", 2);
__decorateClass([
  Field((type) => [String])
], ConvertConfig.prototype, "upsertFieldBlacklist", 2);
ConvertConfig = __decorateClass([
  Entity()
], ConvertConfig);
export {
  BooleanFieldMappingEntry,
  ConvertConfig,
  FieldMappingEntry,
  ForeignKeyMapping,
  MaybeNumberFieldMappingEntry,
  NumberFieldMappingEntry
};
